import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=735bfad4&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style1 from "./Banner.vue?vue&type=style&index=1&id=735bfad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735bfad4",
  null
  
)

export default component.exports